export default __webpack_public_path__ + "static/media/ammirato.836e04cd.jpg";